import { useFeatureAvailable, Feature, useSoftDeployAccess } from 'App/components/hooks/featureHelper';

export default function allowed() {
	const hasFeature = useFeatureAvailable(Feature.ADVANCED_SEARCH) && useSoftDeployAccess('ADVANCED_SEARCH_REACT');

	return hasFeature;
}
